var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5547 5H3.44531C2.51034 5 1.75 5.76034 1.75 6.69531C1.75 7.63029 2.51034 8.39063 3.44531 8.39063H24.5547C25.4893 8.39063 26.25 7.63029 26.25 6.69531C26.25 5.76034 25.4893 5 24.5547 5ZM24.5547 12.6591H3.44531C2.51034 12.6591 1.75 13.4195 1.75 14.3545C1.75 15.2894 2.51034 16.0498 3.44531 16.0498H24.5547C25.4893 16.0498 26.25 15.2894 26.25 14.3545C26.25 13.4195 25.4893 12.6591 24.5547 12.6591ZM24.5547 20.3183H3.44531C2.51034 20.3183 1.75 21.0786 1.75 22.0136C1.75 22.9486 2.51034 23.7089 3.44531 23.7089H24.5547C25.4893 23.7089 26.25 22.9486 26.25 22.0136C26.25 21.0786 25.4893 20.3183 24.5547 20.3183Z",
    fill: "#CDCEC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.3d681e47.svg";
export { ForwardRef as ReactComponent };